<p>This document was last updated on 25 July 2023.</p>

<table class="privacy-policy-table">
  <tbody>
    <tr>
      <td>Name:</td>
      <td>The Vintage Bar ApS</td>
    </tr>
    <tr>
      <td>CVR-no:</td>
      <td>39106744</td>
    </tr>
    <tr>
      <td>Address:</td>
      <td>Prags Boulevard 49A 2300 Copenhagen, Denmark</td>
    </tr>
    <tr>
      <td>Contact:</td>
      <td><a href="mailto:legal@thevintagebar.com" class="link primary">legal@thevintagebar.com</a></td>
    </tr>
  </tbody>
</table>
